import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const CourierSystemPage = () => <ModuleDetailPage moduleId="courier-system" />;

export default CourierSystemPage;
